export const APP_ACCESS_KEYS = {
  MEAL_MANAGER: 'app_meal_manager',
  ACTIVITY_PLANNER: 'app_activity_planner',
};

export const DEFAULT_USER_APP_ACCESS = {
  mealManager: true,
  activityPlanner: true,
};

/** Used when profile cannot be verified, deny app access (fail closed). */
export const DENIED_USER_APP_ACCESS = {
  mealManager: false,
  activityPlanner: false,
};

/**
 * Organisation subscription / feature flags → default user app access.
 * Matches AuthContext: each app is on unless the org flag is explicitly false.
 */
export function orgAppAccessFromFeatures(features) {
  const f = features && typeof features === 'object' ? features : {};
  return {
    mealManager: f[APP_ACCESS_KEYS.MEAL_MANAGER] !== false,
    activityPlanner: f[APP_ACCESS_KEYS.ACTIVITY_PLANNER] !== false,
  };
}

/** Prefer explicit org object; falls back to both apps on when no org. */
export function defaultUserAppAccessForOrg(org) {
  if (!org) return { ...DEFAULT_USER_APP_ACCESS };
  return orgAppAccessFromFeatures(org.features);
}

export function parseUserAppAccess(appAccessJson) {
  if (!appAccessJson || typeof appAccessJson !== 'object') {
    return { ...DEFAULT_USER_APP_ACCESS };
  }
  return {
    mealManager: appAccessJson[APP_ACCESS_KEYS.MEAL_MANAGER] !== false,
    activityPlanner: appAccessJson[APP_ACCESS_KEYS.ACTIVITY_PLANNER] !== false,
  };
}

export function toUserAppAccessDb({ mealManager, activityPlanner }) {
  return {
    [APP_ACCESS_KEYS.MEAL_MANAGER]: mealManager !== false,
    [APP_ACCESS_KEYS.ACTIVITY_PLANNER]: activityPlanner !== false,
  };
}

export function mergeAppAccess(orgAccess, userAccess) {
  const org = orgAccess || DEFAULT_USER_APP_ACCESS;
  const user = userAccess || DEFAULT_USER_APP_ACCESS;
  return {
    mealManager: org.mealManager !== false && user.mealManager !== false,
    activityPlanner: org.activityPlanner !== false && user.activityPlanner !== false,
  };
}

export const SYSTEM_ACCESS_OPTIONS = [
  {
    key: 'mealManager',
    label: 'Meal Manager',
    description: 'Food calendar, meals, and delivery workflows',
    icon: 'UtensilsCrossed',
  },
  {
    key: 'activityPlanner',
    label: 'Activity Planner',
    description: 'Activities, sessions, and resident engagement',
    icon: 'Activity',
  },
];
